import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PuffLoader } from 'react-spinners';

import './style.scss';

import {
  succeedPlaid,
  exitPlaid,
} from '../../actions/plaid';

const Plaid = (props) => {
  const plaidComponent = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  const loadScript = (url, callback) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';

    if (script.readyState) { // IE
      script.onreadystatechange = () => {
        if (script.readyState === 'loaded' || script.readyState === 'complete') {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else { // Others
      script.onload = () => {
        callback();
      };
    }

    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
  };

  const onPlaidLoad = () => {
    setIsLoading(false);
  };

  const onPlaidSuccess = (publicToken, metaData) => {
    props.onPlaidSuccess(publicToken, metaData);
  };

  const onPlaidExit = () => {
    // props.onPlaidExit();
  };

  useEffect(() => {
    const { linkToken } = props;

    loadScript('https://cdn.plaid.com/link/v2/stable/link-initialize.js', () => {
      plaidComponent.current = window.Plaid.create({
        token: linkToken,
        onLoad: onPlaidLoad,
        onSuccess: onPlaidSuccess,
        onExit: onPlaidExit,
      });

      plaidComponent.current.open();
    });
  }, [props.linkToken]);

  return (
    <div className="plaidContainer">
      {isLoading && (
        <PuffLoader
          size={100}
          color="#f44242"
        />
      )}
    </div>
  );
};

Plaid.propTypes = {
  linkToken: PropTypes.string.isRequired,
  onPlaidSuccess: PropTypes.func.isRequired,
  // onPlaidExit: PropTypes.func.isRequired,
};

Plaid.defaultProps = {
};

export default connect(null, { succeedPlaid, exitPlaid })(Plaid);
